



























































































import Vue from 'vue';
import Component from 'vue-class-component';
import FormNavigationButtons from '../common/FormNavigationButtons.vue';
import { Prop } from 'vue-property-decorator';
import { Tickets } from '@/modules/shared/shared/domain/constants/constants';

@Component({
    components: {
        FormNavigationButtons,
    },
})
export default class StepTapeManagementTicketConfirmation extends Vue {
    @Prop({ required: true })
    requirementTicket!: {
        generalInformation: {
            subject: number;
            textSubject: string;
            contactId: number;
            firstName: string;
            lastName: string;
            idNumber: string;
            telephoneNumber: string;
            description: string;
        };
        tapes: {
            giveOrTake: string;
            code: string;
        }[];
    };

    isFormValid: boolean = true;
    $refs!: {
        form: any;
    };

    get showTapeDeliverySheets() {
        if (
            this.requirementTicket.generalInformation.subject ===
            Tickets.REQUIREMENT.typings.tapeChange.id
        ) {
            return true;
        }
        return false;
    }

    validateStep() {
        if (this.$refs.form.validate()) {
            this.$emit('nextStep');
        }
    }

    sendRequirementTicket() {
        this.$emit('sendRequirementTicket');
    }

    previousStep() {
        this.$emit('previousStep');
    }

    reset() {
        this.$emit('reset');
    }

    openTapeDeliveryReceptionSheet() {
        if (this.requirementTicket.tapes) {
            this.requirementTicket.tapes = this.requirementTicket.tapes.sort(
                (a, b) => b.giveOrTake.length - a.giveOrTake.length,
            );
        }

        localStorage.setItem('requirementTicket', JSON.stringify(this.requirementTicket));
        let to = { name: 'tape-delivery-reception' };
        let routeData = this.$router.resolve(to);
        window.open(routeData.href + '?localStorage=false', '_blank');
    }
}
